import React, {Fragment, useState} from 'react'
import {Input as AntInput} from 'antd'
import utils from '@eitje/utils'
import _ from 'lodash'
import {usePreserveInputSelection} from './use_preserve_input_selection'

const DEFAULT_AUTOSIZE = {minRows: 1, maxRows: 12}

const change = (props, val, event) => {
	const {formatValue, onChange} = props
	let newVal = val
	if (formatValue) {
		newVal = formatValue(val)
		if (_.isNaN(newVal)) return
	}
	newVal = sanitizeInput(newVal)
	onChange(newVal, event)
}

function sanitizeInput(value) {
	if (typeof value !== 'string') return value
	// below regex is meant to remove invisible format characters..
	return value.replace(/\p{Cf}/gu, '')
}

const Input = props => {
	const {
		value,
		secure,
		textarea,
		suffix,
		charCounterProps = {},
		innerRef,
		newForm,
		hideCharCounter,
		maxLength,
		autocomplete = 'nope',
		autoSize = DEFAULT_AUTOSIZE,
		disableAutoComplete,
		readOnly,
		remapSelection,
		...rest
	} = props
	const InputEl = textarea ? AntInput.TextArea : secure ? AntInput.Password : AntInput
	const _suffix = utils.funcOrVal(suffix, props)

	const [autoCompleteUnlocked, setAutoCompleteUnlocked] = useState(!disableAutoComplete)
	const {setRefs, storeSelection, clearSelection} = usePreserveInputSelection({
		innerRef,
		value,
		remapSelection,
	})

	const handleFocus = e => {
		if (disableAutoComplete && !autoCompleteUnlocked) setAutoCompleteUnlocked(true)
		props.onFocus?.(e)
	}

	const handleBlur = e => {
		clearSelection()
		props.onBlur?.(e)
	}

	return (
		<Fragment>
			<InputEl
				autoComplete={autocomplete}
				className="eitje-input"
				ref={setRefs}
				maxLength={maxLength}
				{...rest}
				suffix={_suffix}
				value={value}
				{...(textarea ? {autoSize} : {})}
				onChange={e => {
					storeSelection(e)
					change(props, e.target.value, e)
				}}
				onFocus={handleFocus}
				onBlur={handleBlur}
				readOnly={(!autoCompleteUnlocked && disableAutoComplete) || readOnly}
			/>
			{!newForm && !!maxLength && !hideCharCounter && <CharCounter value={value} maxLength={maxLength} {...charCounterProps} />}
		</Fragment>
	)
}

const makeCharClass = (charsLeft, {warningThreshold = 10, dangerThreshold = 5}) => {
	if (charsLeft < dangerThreshold) return 'char-counter-danger'
	if (charsLeft < warningThreshold) return 'char-counter-warning'
	return ''
}

const CharCounter = ({maxLength, value = '', ...rest}) => {
	const charsLeft = maxLength - (value?.length || 0)
	const className = makeCharClass(charsLeft, rest)
	return <p className={`char-counter ${className}`}>{charsLeft}</p>
}

export default Input
